import { appendAppLog } from '../platform/appLog';
import { ServerFehler } from './client';

/**
 * Ob gerade eine Verbindung zum Server besteht — damit ein Prüfungstag ohne Netz das Dateilog
 * nicht füllt.
 *
 * Vorgabe des Nutzers (2026-10-02): offline ist der Normalfall, und im Gerätelauf standen
 * 42 Netzfehlerzeilen in 160 Sekunden im Log. Jetzt gibt es **eine** Zeile, wenn die Verbindung
 * wegbricht (die Deutung aus `netzfehler.ts`), und **eine**, wenn sie zurückkommt — mit der
 * Zahl der Fehlversuche dazwischen.
 *
 * ⚠️ **Eine Lage für alle.** Relay- und Classic-Client, Takt und Katalog teilen sie: ein
 * fehlendes WLAN ist ein Zustand des Geräts, nicht eines einzelnen Aufrufs.
 */
export interface Verbindungslage {
  /** Ein Aufruf kam nicht durch. `true` heisst: der erste dieser Phase, er soll ins Log. */
  ausfall: () => boolean;
  /** Der Server hat geantwortet (gleich was). Beendet eine Offline-Phase. */
  erfolg: () => void;
}

export function erstelleVerbindungslage(log: (zeile: string) => void): Verbindungslage {
  let fehlversuche = 0;
  let seit: Date | null = null;
  return {
    ausfall: () => {
      fehlversuche += 1;
      if (fehlversuche > 1) return false;
      seit = new Date();
      return true;
    },
    erfolg: () => {
      if (fehlversuche === 0) return;
      const p = (v: number) => String(v).padStart(2, '0');
      const ab = seit ? ' seit ' + p(seit.getHours()) + ':' + p(seit.getMinutes()) : '';
      log('Verbindung zum Server wieder da' + ab + ', nach ' + String(fehlversuche) + ' Fehlversuchen.');
      fehlversuche = 0;
      seit = null;
    },
  };
}

/** Kam der Aufruf gar nicht beim Server an? Eine Ablehnung (4xx/5xx) ist eine Antwort. */
export const istNetzausfall = (fehler: unknown): boolean =>
  fehler instanceof ServerFehler && (fehler.art === 'keineVerbindung' || fehler.art === 'zeitueberschreitung');

/** Die eine Lage der App. */
export const verbindung = erstelleVerbindungslage(
  (zeile) => void appendAppLog(zeile).catch(() => undefined),
);
